// Маппер категорий заданий

import type { JobCategoryDto, JobCategoryRaw } from '../types/job-category.types';

export function mapJobCategory(raw: JobCategoryRaw): JobCategoryDto {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    glyph: raw.glyph ?? null,
    bgColor: raw.bg_color ?? null,
    sortOrder: raw.sort_order,
    isActive: !!raw.is_active,
  };
}
